export const brandingLight = '#CFF7F3'
export const brandingDark = '#008083'
